module.exports = __webpack_public_path__ + "img/C-bottom.3106099c.png";